import { merchantApi } from '@/config/axios'

export interface O2oReservationMerchantPageReqVO {
  pageNo: number
  pageSize: number
  orderId?: number
  storeId?: number
  providerId?: number
  appointmentDate?: string
  status?: string
  contactPhone?: string
}

export interface O2oReservationMerchantRespVO {
  id: number
  orderId?: number
  serviceId?: number
  storeId?: number
  providerId?: number
  appointmentDate?: string
  appointmentTime?: string
  contactName?: string
  contactPhone?: string
  address?: string
  remark?: string
  status?: string
  createTime?: string
}

export interface O2oReservationRescheduleReqVO {
  id: number
  appointmentDate: string
  appointmentTime: string
  remark?: string
}

export interface O2oReservationCancelReqVO {
  id: number
  remark?: string
}

export function getO2oMerchantReservationPage(params: O2oReservationMerchantPageReqVO) {
  return merchantApi.get<{ list: O2oReservationMerchantRespVO[]; total: number }>({
    url: '/merchant-api/o2o/reservation/page',
    params
  })
}

export function getO2oMerchantReservation(id: number) {
  return merchantApi.get<O2oReservationMerchantRespVO>({
    url: '/merchant-api/o2o/reservation/get',
    params: { id }
  })
}

export function rescheduleO2oMerchantReservation(data: O2oReservationRescheduleReqVO) {
  return merchantApi.put<boolean>({
    url: '/merchant-api/o2o/reservation/reschedule',
    data
  })
}

export function cancelO2oMerchantReservation(data: O2oReservationCancelReqVO) {
  return merchantApi.put<boolean>({
    url: '/merchant-api/o2o/reservation/cancel',
    data
  })
}
